export const faq = [
	{
		question: 'How do I choose the right size?',
		answer: 'Use the size information on each product page and compare it with your measurements. If you are between sizes, contact our customer care team before ordering.',
	},
	{
		question: 'How long does delivery take?',
		answer: 'Orders within Tashkent usually arrive in 1–2 business days. Delivery to other regions normally takes 3–5 business days.',
	},
	{
		question: 'Can I return or exchange an item?',
		answer: 'Yes. Unworn items with their original tags can be returned or exchanged within 14 days of delivery.',
	},
	{
		question: 'How can I track my order?',
		answer: 'Sign in and open your Orders page to see the latest status. We will also contact you when your order is ready for delivery.',
	},
	{
		question: 'Can I change or cancel my order?',
		answer: 'Contact us as soon as possible. We can change or cancel an order before it has been prepared for dispatch.',
	},
	{
		question: 'Which payment methods do you accept?',
		answer: 'Available payment options are shown during checkout. All payments are processed through secure payment providers.',
	},
];
